module.exports = __webpack_public_path__ + "static/media/courierBag.3cc1ae0c.svg";